import {
  addUniqueValueToArray
} from 'utils/redux'
import { INIT } from './view'

export const NAMESPACE = 'KanBo/MyBoard/visitors/'
export const ADD = NAMESPACE + 'ADD'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'

const initialState = []

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case INIT:
      return [
        ...initialState
      ]
    case ADD:
      return addUniqueValueToArray({
        array: state,
        value: action.payload.id,
        index: action.payload.index
      })
    case ADD_ARRAY: {
      let newState = [ ...state ]
      action.payload.forEach(userId => {
        newState = addUniqueValueToArray({
          array: newState,
          value: userId
        })
      })
      return newState
    }
    case REMOVE:
      return state.indexOf(action.payload.id) !== -1
      ? state.filter(id => id !== action.payload.id)
      : state
    default: return state
  }
}

export function add ({ id, index }) {
  return {
    type: ADD,
    payload: {
      id,
      index
    }
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}
